<p class="validation-error-row" *ngFor="let error of (errors$ | async) | keyValues">{{ error.value.message }}</p>
